import { updateObject } from "../Utility";
import {
  REJECTION_REASONS_GET_START,
  REJECTION_REASONS_GET_SUCCESS,
  REJECTION_REASONS_GET_FAIL,
} from "../actions/RejectionReasonsActions";

const initialState = {
  items: {},
  itemsArray: [],
  loading: false,
  fetched: false,
  error: null,
};

// GET:
const getRejectionReasonsStart = (state, actions) => {
  return updateObject(state, {
    ...state,
    loading: true,
    error: null,
  });
};

const getRejectionReasonsSuccess = (state, action) => {
  return updateObject(state, {
    ...state,
    items: action.rejectionReasons.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {}),
    itemsArray: action.rejectionReasons,
    loading: false,
    fetched: true,
    error: null,
  });
};

const getRejectionReasonsFail = (state, action) => {
  return updateObject(state, {
    ...state,
    loading: false,
    error: action.error,
  });
};

const RejectionReasonsReducer = (state = initialState, action) => {
  switch (action.type) {
    // GET:
    case REJECTION_REASONS_GET_START:
      return getRejectionReasonsStart(state, action);
    case REJECTION_REASONS_GET_SUCCESS:
      return getRejectionReasonsSuccess(state, action);
    case REJECTION_REASONS_GET_FAIL:
      return getRejectionReasonsFail(state, action);

    default:
      return state;
  }
};

export default RejectionReasonsReducer;
